import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import AccountDelete from "../../Modules/ManageProfile/AccountDelete";
import { useSelector } from "react-redux";
import RoleBaseModel from "../../CustomComponents/RoleBaseModel";
// Make sure to import RoleBaseModel here:
// import RoleBaseModel from "..."; 

export default function DashBoardSidebar({ setsidebar }) {
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);
  const reduxRoleType = profile?.role_type;

  const {
    setManageworkProjeteroute,
    setManageworkContestroute,
    setTeamroute,
    setManageworkJobroute,
    setMyOrderroute,
    setTeamMemberroute,
  } = useRouteBaseStateContext();
  
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [modal, setModal] = useState(false); // Logout Modal
  const [modal1, setModal1] = useState(false); // Delete Account Modal
  const [roleModal, setRoleModal] = useState(false); // Role Base Modal

  const location = useLocation();
  const navigate = useNavigate();
  const path = "Assets/scss/dashboard.module.scss";
  
  const role_type = localStorage.getItem("role_type") || reduxRoleType;
  const token = localStorage.getItem("urexperttoken");

  // Detect if device is mobile
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const isCurrentPath = (paths) => {
    return paths.some((path) => {
      if (path === `/${lan}/dashboard`) {
        return location.pathname === path;
      }
      return location.pathname.includes(path);
    });
  };

  const highlightStyle = (paths) => {
    return isCurrentPath(paths) ? { background: "#FFF2E7" } : {};
  };

  // Mobile navigation handler that closes sidebar
  const handleMobileNavigation = (path, callback = null) => {
    if (isMobile) {
      // Close mobile sidebar by triggering a custom event
      const sidebarCloseEvent = new CustomEvent("closeMobileSidebar");
      document.dispatchEvent(sidebarCloseEvent);
    }

    if (callback) {
      callback();
    }
    navigate(path);
    setsidebar(false);
  };

  const LogoutMethod = () => {
    localStorage.removeItem("urexperttoken");
    localStorage.removeItem("role_type");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("urlState");
    navigate(`/${lan}`);
    // window.location.reload()
  };

  // Handler for Work Samples Click
  const handleWorkSampleClick = () => {
    if ((role_type == 1 || role_type == 2) && token !== null) {
      // If condition matches, show the RoleBaseModel
      setRoleModal(true);
    } else {
      // Otherwise, navigate normally
      handleMobileNavigation(`/${lan}/dashboard/manageportfolio`);
    }
  };

  // Handler for Post & Browse Projects (PBP) Click
  const handlePBPClick = () => {
    if ((role_type == 1 || role_type == 2) && token !== null) {
      setRoleModal(true);
    } else {
      handleMobileNavigation(`/${lan}/dashboard/managework/projects`, () => {
        setManageworkProjeteroute("");
      });
    }
  };

  // Handler for Win business Opportunities (WBO) Click
  const handleWBOClick = () => {
    if ((role_type == 1 || role_type == 2) && token !== null) {
      setRoleModal(true);
    } else {
      handleMobileNavigation(`/${lan}/dashboard/managework/contests`, () => {
        setManageworkContestroute("");
      });
    }
  };

  // Handler for Part time Job Click
  const handlePartTimeJobClick = () => {
    if ((role_type == 1 || role_type == 2) && token !== null) {
      // If condition matches, show the RoleBaseModel
      setRoleModal(true);
    } else {
      // Otherwise, navigate normally and run the original callback
      handleMobileNavigation(`/${lan}/dashboard/managework/jobs`, () => {
        setManageworkJobroute("");
      });
    }
  };

  return (
    <>
      <div className="dashboard-sidebar">
        <h6>Main</h6>
        <div className="sidebar-menu">
          <a
            style={highlightStyle([`/${lan}/dashboard`])}
            onClick={() => handleMobileNavigation(`/${lan}/dashboard`)}
          >
            Dashboard
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/myorders`])}
            onClick={() => {
              handleMobileNavigation(`/${lan}/dashboard/myorders`, () => {
                setMyOrderroute("");
              });
            }}
          >
            My Orders
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/receivedorders`])}
            onClick={() =>
              handleMobileNavigation(`/${lan}/dashboard/receivedorders`)
            }
          >
            Received Orders
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/myotsproducts`])}
            onClick={() =>
              handleMobileNavigation(`/${lan}/dashboard/myotsproducts`)
            }
          >
            All Services
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/wallet`])}
            onClick={() => handleMobileNavigation(`/${lan}/dashboard/wallet`)}
          >
            Wallet
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/reports`])}
            onClick={() => handleMobileNavigation(`/${lan}/dashboard/reports`)}
          >
            Reports
          </a>
        </div>
        <h6>Manage Work</h6>
        <div className="sidebar-menu">
          {/* UPDATED POST & BROWSE PROJECTS LINK */}
          <a
            style={highlightStyle([`/${lan}/dashboard/managework/projects`])}
            onClick={handlePBPClick}
          >
            Post & Browse Projects (PBP)
          </a>

          {/* UPDATED WIN BUSINESS OPPORTUNITIES LINK */}
          <a
            style={highlightStyle([`/${lan}/dashboard/managework/contests`])}
            onClick={handleWBOClick}
          >
            Win business Opportunities (WBO)
          </a>

          {/* UPDATED PART TIME JOB LINK */}
          <a
            style={highlightStyle([`/${lan}/dashboard/managework/jobs`])}
            onClick={handlePartTimeJobClick}
          >
            Part time Job (PTJ)
          </a>

          {role_type !== "2" && (
            <a
              style={highlightStyle([`/${lan}/dashboard/manageteams`])}
              onClick={() => {
                handleMobileNavigation(`/${lan}/dashboard/manageteams`, () => {
                  setTeamroute("");
                  setTeamMemberroute(false);
                });
              }}
            >
              Teams
            </a>
          )}
        </div>
        <h6>My Profile</h6>
        <div className="sidebar-menu">
          <a
            style={highlightStyle([`/${lan}/dashboard/manageprofile`])}
            onClick={() =>
              handleMobileNavigation(`/${lan}/dashboard/manageprofile`)
            }
          >
            Manage profile
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/manageportfolio`])}
            onClick={handleWorkSampleClick}
          >
            Work samples
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/membership`])}
            onClick={() =>
              handleMobileNavigation(`/${lan}/dashboard/membership`)
            }
          >
            Membership
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/downloads`])}
            onClick={() => {
              handleMobileNavigation(`/${lan}/dashboard/downloads`, () => {
                localStorage.setItem("downloaded", 1);
              });
            }}
          >
            Downloads
          </a>
          <a
            style={highlightStyle([`/${lan}/dashboard/contactus`])}
            onClick={() => {
              handleMobileNavigation(`/${lan}/dashboard/contactus`, () => {
                localStorage.setItem("downloaded", 1);
              });
            }}
          >
            Contact us
          </a>
        </div>
        <h6>Settings</h6>
        <div className="sidebar-menu">
          <a
            style={highlightStyle([`/${lan}/dashboard/preferences`])}
            onClick={() => {
              handleMobileNavigation(`/${lan}/dashboard/preferences`, () => {
                if (role_type == 1 || role_type == 2) {
                  navigate(`/${lan}/registration`, {
                    state: { joinasa: "expert", type: 1 },
                  });
                }
              });
            }}
          >
            Preferences
          </a>
          <a onClick={() => setModal1((state) => !state)}>Delete Account</a>
          <a onClick={() => setModal((state) => !state)}>Logout</a>
        </div>

        {/* LOGOUT MODAL */}
        <Modal
          className="popupmodal logout"
          isOpen={modal}
          toggle={() => setModal(false)}
        >
          <button
            onClick={() => setModal((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <ModalBody>
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/info-circle.svg`}
              alt=""
            />
            <h4>Logout</h4>
            <p>Are you sure you want to logout</p>
          </ModalBody>
          <div className="modal-footer mt-3">
            <button
              className="btn"
              onClick={() => {
                setModal((state) => !state);
                LogoutMethod();
              }}
            >
              Yes
            </button>
          </div>
        </Modal>

        <AccountDelete model={modal1} setModel={setModal1} />

        {/* ROLE BASE MODAL */}
        {roleModal && (role_type == 1 || role_type == 2) && token !== null && (
          <Modal
            isOpen={roleModal}
            keyboard={false}
            className="modal-centered popupmodal"
          >
            <RoleBaseModel setModal={setRoleModal} />
          </Modal>
        )}
      </div>
    </>
  );
}